import React, {useState, useEffect} from 'react';
import { ReCaptcha, loadReCaptcha } from 'react-recaptcha-v3'
import WeexModal from '../../comps/weexModais/WeexModal';
import WeexInput from '../../comps/WeexInput';
import WeexMessage from '../../comps/WeexMessage';
import {Link, useHistory} from 'react-router-dom';
import CampanhaService from '../../services/CampanhaService';
import {useStore} from 'react-redux';

function RegisterCampaign(props) {
    const [request, setRequest] = useState({firstName:null, email:null, lastName:null, password1:null, password2:null, birthday:null, unit: null, age:18})
    const [accept, setAccept] = useState(false)
    const [captcha, setCaptcha] = useState(false)
    const [erro, setErro] = useState(null)
    const [processando, setProcessando] = useState(false)
    const [processandoInicio, setProcessandoInicio] = useState(false)
    const [opcoes, setOpcoes] = useState()
    const history = useHistory()

    const i18n = useStore().getState().i18n; 

    const onChange = (event) => {
        let req = request
        req[event.target.name] = event.target.value
        
        setRequest(req)
    }

    const onChangeAccept = (event) => {
        setAccept(event.target.checked)
    }

    const registro = (event) => {

        if (! props.campanha) {
            alert("Sem campanha")
        }

        event.preventDefault()
        if (processando) {
            return
        }
        setProcessando(true)
        if(request.unit == null && props.campanha.client && props.campanha.client.units && props.campanha.client.units.length > 0){
            request.unit = props.campanha.client.units[0].uuid
        }
        if (! accept) {
            setErro({
                titulo:i18n.message("registro.erro.legal.titulo", "Aceite nossas condições"), 
                mensagem:i18n.message("registro.erro.legal.mensagem", "Você não aceitou os termos e condições do Weex.")})
            setProcessando(false)
            return
        }
        if (expoeDataNascimento) {
            if(request.birthday.length != 10){
                setErro({
                    titulo:i18n.message("registro.erro.nascimento.titulo", "Data de nascimento inválida"), 
                    mensagem:i18n.message("registro.erro.nascimento.mensagem", "A data de nascimento que você digitou é inválida.")
                    })
                setProcessando(false)
                return
            }
            let camposData = request.birthday.split("/")
            if (props.campanha.tipoInscricao === 'MATRICULA') {
                if(new Date() < new Date((parseInt(camposData[2]) + 18), (parseInt(camposData[1]) - 1), camposData[0])){
                    setErro(
                        {
                        titulo:i18n.message("registro.erro.nascimento.titulo", "Data de nascimento inválida"), 
                        mensagem:i18n.message("registro.erro.nascimento18.mensagem", "Idade menor que 18.")})
                    setProcessando(false)
                    return
                }
            } else {
                if(new Date() < new Date((parseInt(camposData[2]) + 13), (parseInt(camposData[1]) - 1), camposData[0])){
                    setErro({
                        titulo:i18n.message("registro.erro.nascimento.titulo", "Data de nascimento inválida"), 
                        mensagem:"Idade menor que 13."})
                    setProcessando(false)
                    return
                }
            }
            if(camposData[1] > 12 || camposData[1] < 1){
                setErro({
                    titulo:i18n.message("registro.erro.nascimento.titulo", "Data de nascimento inválida"), 
                    mensagem:i18n.message("registro.erro.nascimentomes.mensagem", "Mês " + camposData[1] + " é inválido, meses válidos entre 1 e 12 inclusos esses valores.")})
                setProcessando(false)
                return
            }
            let ultimoDiaMes = new Date(camposData[2], camposData[1], 0).getDate()
            if(camposData[0] > ultimoDiaMes || camposData[0] < 1){
                setErro({
                    titulo:i18n.message("registro.erro.nascimento.titulo", "Data de nascimento inválida"), 
                    mensagem: i18n.message("registro.erro.nascimentodia.mensagem",  "Dia " + camposData[0] + " é inválido, válidos para o mês " + camposData[1] + "/" + camposData[2] + " entre 1 e " + ultimoDiaMes + " inclusos esses valores.")})
                setProcessando(false)
                return
            }            
        }

        if (expoeIdade) {
            if (props.campanha.tipoInscricao === 'MATRICULA') {
                if(request.age < 18){
                    setErro({
                        titulo:i18n.message("registro.erro.idade.titulo", "Idade inválida"), 
                        mensagem:i18n.message("registro.erro.idade.menor18", "Menor que 18.")})
                    setProcessando(false)
                    return
                }
            } else if(request.age < 13){
                setErro({
                    titulo:i18n.message("registro.erro.idade.titulo", "Idade inválida"), 
                    mensagem:i18n.message("registro.erro.idade.menor13", "Menor que 13.")})
                setProcessando(false)
                return
            }
        }

        if (request.password1 !== request.password2) {
            setErro({
                titulo:i18n.message("registro.erro.senhas.titulo", "Senhas não conferem"), 
                mensagem:i18n.message("registro.erro.senhas.mensagem", "As senhas que você digitou não conferem.")})
            setProcessando(false)
            return
        }

        const service = new CampanhaService()
        const campanhaCorrente = service.campanhaCorrente();
        const requiredInterests = campanhaCorrente.requiredInterests;
        const inscricao = {birthDate: request.birthday,
                           enrollment:request.enrollment, 
                           email:request.email, 
                           firstName:request.firstName, 
                           lastName:request.lastName, 
                           password:request.password1, 
                           campaign:props.campanha.code,
                           unit: request.unit,
                           age: request.age}
        service.inscrever(inscricao, (erro, sucesso) => {
            if (erro) {
                setProcessando(false)
                if (erro.response && erro.response.data && erro.response.data.message) {
                    setErro({
                        titulo:i18n.message("registro.erro.inscricao.titulo", "Erro na inscrição"), 
                        mensagem:erro.response.data.message})
                } else {
                    setErro({
                        titulo:i18n.message("registro.erro.inscricao.titulo", "Erro na inscrição"), 
                        mensagem: i18n.message("geral.erro.network.mensagem", "Falha ao tentar se registrar, entre em contato com o suporte ou tente novamente mais tarde")})
                }
                return
            } 
            if (sucesso) {
                setProcessando(false)
                if (sucesso.authorization) {
                    props.callbackLogin(sucesso)
                    service.contadorCampanha((erro, sucesso)=>{
                        if(erro){
                            setErro({titulo: i18n.message("atividades.erro.dias.habilitados", "Erro obter lista de dias habilitados")})
                            return;
                        }
                        if(sucesso){
                            if(sucesso !== null){
                                if(sucesso.length > 0 ){
                                    history.push('/atividades')
                                } else {
                                    history.push("/home")
                                }
                            }
                        }
                    })
                } else {
                    setErro({titulo:i18n.message("registro.erro.aposInscricao.titulo", "Sobre sua inscrição"), 
                    mensagem:sucesso.message})
                }
            }

        })
    }
    
    const callbackWarning = () => {
        setErro(null)
    }

    const recaptchaToken =  process.env.REACT_APP_RECAPTCHA_SITE_TOKEN;
    const minScore =  process.env.REACT_APP_RECAPTCHA_MIN_SCORE;

    const verifyCallback = (recaptchaToken) => {
        const service = new CampanhaService()
        service.validarRecaptcha(recaptchaToken, (erro, sucesso) => {
            if(sucesso){
                if(sucesso.success && parseFloat(sucesso.score) > parseFloat(minScore)){
                    setCaptcha(true)
                }else{
                    setCaptcha(false)
                    setErro({
                        titulo:i18n.message("registro.erro.recaptcha.titulo", "Recaptcha"), 
                        mensagem:i18n.message("registro.erro.recaptcha.mensagem", "A verificação do recaptcha falhou")})
                }
            }else if (erro) {
                if (erro.response && erro.response.data && erro.response.data.message) {
                    setErro({
                        titulo:i18n.message("registro.erro.inscricao.titulo", "Erro na inscrição"), 
                        mensagem:erro.response.data.message})
                } else {
                    setErro({
                        titulo:i18n.message("registro.erro.inscricao.titulo", "Erro na inscrição"), 
                        mensagem: i18n.message("geral.erro.network.mensagem", "Falha ao tentar se registrar, entre em contato com o suporte ou tente novamente mais tarde")})
                }
                return
            }
        })
    }
    
    useEffect(() => {
        if(campanha.captcha){
            loadReCaptcha(recaptchaToken, () => {});
        } else {
            setCaptcha(true)
        }
    }, [])

    const campanha = new CampanhaService().campanhaCorrente();
    if (! campanha || ! campanha.tipoInscricao) {

        new CampanhaService().clearAll()
		if (! window.location.href.endsWith("select")) {
			window.location = "/select"
		}

    }
    const tipoInscricao = campanha.tipoInscricao;
    const nomeMatricula = campanha.nomeMatricula;
    const coletaIdade = campanha.ageType;

    const expoeCampoEmail = (tipoInscricao !== 'MATRICULA')
    const expoeCampoMatricula = (tipoInscricao !== 'EMAIL')
    const expoeDataNascimento = (coletaIdade === 'DATE')
    const expoeIdade = (coletaIdade === 'AGE')

    return (
        <form onSubmit={registro}>
            { erro != null ? (
                <WeexModal callback={callbackWarning} visivel={erro != null} titulo={erro.titulo} conteudo={erro.mensagem}/>
            ) : null}
            <WeexInput type="text" name="firstName" label={i18n.message("registro.campo.nome", "Nome")} onChange={onChange} required={true}/>
            <WeexInput type="text" name="lastName" label={i18n.message("registro.campo.sobrenome", "Sobrenome")} onChange={onChange} required={true}/>
            {expoeCampoMatricula ? 
                (<WeexInput type="text" name="enrollment" label={nomeMatricula} onChange={onChange} required={true}/>) : null}
            {expoeCampoEmail && ! expoeCampoMatricula ? 
                (<WeexInput type="email" name="email" label={i18n.message("registro.campo.email", "E-mail")} onChange={onChange} required={true}/>)
                : null}
            {expoeCampoEmail &&  expoeCampoMatricula ? 
                (<WeexInput type="email" name="email" label={i18n.message("registro.campo.email", "E-mail")} onChange={onChange} required={false}/>)
                : null}
            {expoeDataNascimento ?
                (<WeexInput type="text" name="birthday" label={i18n.message("registro.campo.nascimento", "Data de nascimento")} onChange={onChange} required={expoeDataNascimento} mascara="99/99/9999" legenda="DD/MM/AAAA"/>)
                : null
            }
            {expoeIdade ?
                (<WeexInput type="listaNumero" name="age" label={i18n.message("registro.campo.idade", "Idade")} value={request.age} min={14} max={100} onChange={onChange} required={expoeIdade} />)
                : null
            }
            { props.campanha.client.units && props.campanha.client.units.length > 0 ? (
                <div className="field">
                    <label className="label"><WeexMessage code="registro.campo.area" default="Selecione sua área"/></label>
                    <div className="select weex-select">
                        <select value={request.unit} name="unit" onChange={onChange} required>
                            {
                            props.campanha.client.units.map((opcao) => {
                                return <option value={opcao.uuid} key={opcao.uuid}>{opcao.name}</option>
                            })
                        }
                        </select>
                    </div>
                </div>
            ) : (null)}
            <WeexInput type="password" name="password1" label={i18n.message("registro.campo.senha", "Senha")} onChange={onChange} required={true}/>
            <WeexInput type="password" name="password2" label={i18n.message("registro.campo.senha2", "Confirme sua senha")} onChange={onChange} required={true}/>
            <label className="checkbox" style={{textAlign:'center', marginTop:'2.0em', marginBottom:'2.0em'}}>
                <input onChange={onChangeAccept} type="checkBox" name="aceito"/>&nbsp;&nbsp;{i18n.message("registro.legal.liaceito", "Li e aceito os")} <a href="https://weex.digital/politica-de-privacidade-e-uso/" target="_blank">{i18n.message("registro.legal.termos", "Termos e Condições")}</a> {i18n.message("registro.legal.daweex", "da Weex")}
                
                
            </label>
            <ReCaptcha
                sitekey={recaptchaToken}
                action='register'
                verifyCallback={verifyCallback}
            />
            <p style={{textAlign:'center', marginTop:'1.0em'}}>
                <input className={accept || captcha ? 'weex-button' : 'weex-button__disabled'} type="submit" value={processando ? i18n.message("geral.aguarde", "Aguarde...") : i18n.message("registro.criar", "Criar Conta")} />
                <br/><br/>
                {
                expoeCampoEmail ? (<Link to="/resetPassword">{i18n.message("registro.resetsenha", "Esqueci minha senha")}</Link>) : null
                }
            </p>

            {campanha.restrictEligibility ? (
                <p style={{textAlign:'center', marginTop:'1.0em'}}>
                    {
                    <Link to="/">{i18n.message("geral.voltar", "Voltar")}</Link>
                    }
                </p>
            ) : null}
        </form>
    )
}

export default RegisterCampaign;